import { render, staticRenderFns } from "./data7.vue?vue&type=template&id=513a8e6a&scoped=true&"
import script from "./data7.vue?vue&type=script&lang=js&"
export * from "./data7.vue?vue&type=script&lang=js&"
import style1 from "./data7.vue?vue&type=style&index=1&id=513a8e6a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "513a8e6a",
  null
  
)

export default component.exports